import { jsx as _jsx } from "react/jsx-runtime";
import BoxImpersonate from "./BoxImpersonate";
import "../styles/Header.css";
function Header() {
    return (_jsx("header", { children: _jsx(BoxImpersonate, {}) }));
}
export default Header;
